import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";

const ComplaintReply = ({
  showFilter = false,
  filterToggle,
  internalStatus,
  applyFilter,
  documentUploadUrlPublic
}) => {
  const filterInputs = {
    message:'',
    send_to:'',
    attachment_mand:false,
    attachment_file:''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");
  //console.log('filter data ' + JSON.stringify(filterFieldsData));
  const handledropDownChange = async (e) => {
    if(e){
      setFilterFieldsData({ ...filterFieldsData, attachment_mand: false })
    }
   };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
    <div className={showFilter ? "show-filter" : ""}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Assign Ticket</h4>
            <Button onClick={filterToggle} className="close">
              <i className="close"></i>
            </Button>
          </div>
          {console.log(filterFieldsData)}
          <div className="filter-body scrollbar-styling">
          {/* <div className="col-sm-12"> */}
            <TextAreaInput
                  name="message"
                  type="text"
                  rows={8}
                  className={`inline-css scrollbar-styling`}
                  label={localization.message}
                  value={filterFieldsData?.message}
                  inputValue={filterFieldsData?.message}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => setFilterFieldsData({ ...filterFieldsData, message: e.target.value })}
                />
            {/* </div> */}
            {/* <ConstantInput
              label={`Message`}
              value={filterFieldsData && filterFieldsData?.message}
              regex={Regex.number.test(
                filterFieldsData && filterFieldsData?.message
              )}
              handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, message: val });
              }}
            /> */}
            {internalStatus == 'Client Pending' ? 
                <DropDownInput
                label="Send To"
                data={[
                    {
                      id: "Client",
                      name: "Client",
                    },
                    {
                      id: "l2_ticket",
                      name: "L2 Ticket",
                    },
                    {
                      id: "rm_ticket",
                      name: "RM Ticket",
                    },
                    {
                      id: "client_pending_cost",
                      name: "Client(Pending Cost approval)",
                    },
                    {
                      id: "ct_ticket",
                      name: "Central Tech Engineer",
                    },
                    {
                      id: "cx_pending",
                      name: "CX Pending",
                    }
                  ]}
                required
                errorMsg={`Send To`}
                getIdValue={(val) => {
                  setFilterFieldsData({ ...filterFieldsData, send_to: val?.id });
                }}
                isStarRequired={true}
              />
            :
            internalStatus == 'L2 Pending' ? 
              <DropDownInput
                  label="Send To"
                  data={[
                    {
                      id: "Client",
                      name: "Client",
                    },
                    {
                      id: "l2_ticket",
                      name: "L2 Ticket",
                    },
                    {
                      id: "rm_ticket",
                      name: "RM Ticket",
                    },
                    {
                      id: "client_pending_cost",
                      name: "Client(Pending Cost approval)",
                    },
                    {
                      id: "ct_ticket",
                      name: "Central Tech Engineer",
                    },
                    {
                      id: "cx_pending",
                      name: "CX Pending",
                    }
                  ]}
                  required
                  errorMsg={`Send To`}
                  getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, send_to: val?.id });
                  }}
                  isStarRequired={true}
                />
                :
              internalStatus == 'RM Pending' ? 
              <DropDownInput
                  label="Send To"
                  data={[
                    {
                      id: "Client",
                      name: "Client",
                    },
                    {
                      id: "l2_ticket",
                      name: "L2 Ticket",
                    },
                    {
                      id: "rm_ticket",
                      name: "RM Ticket",
                    },
                    {
                      id: "client_pending_cost",
                      name: "Client(Pending Cost approval)",
                    },
                    {
                      id: "ct_ticket",
                      name: "Central Tech Engineer",
                    },
                    {
                      id: "cx_pending",
                      name: "CX Pending",
                    }
                  ]}
                  required
                  errorMsg={`Send To`}
                  getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, send_to: val?.id });
                  }}
                  isStarRequired={true}
                />
                :
                internalStatus == 'Client Pending for Cost Approval' ? 
                  <DropDownInput
                  label="Send To"
                  data={[
                    {
                      id: "Client",
                      name: "Client",
                    },
                    {
                      id: "l2_ticket",
                      name: "L2 Ticket",
                    },
                    {
                      id: "rm_ticket",
                      name: "RM Ticket",
                    },
                    {
                      id: "client_pending_cost",
                      name: "Client(Pending Cost approval)",
                    },
                    {
                      id: "ct_ticket",
                      name: "Central Tech Engineer",
                    },
                    {
                      id: "cx_pending",
                      name: "CX Pending",
                    }
                  ]}
                  required
                  errorMsg={`Send To`}
                  getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, send_to: val?.id });
                  }}
                  isStarRequired={true}
                />
                :<>
                <DropDownInput
                  label="Send To"
                  data={[
                    {
                      id: "Client",
                      name: "Client",
                    },
                    {
                      id: "l2_ticket",
                      name: "L2 Ticket",
                    },
                    {
                      id: "rm_ticket",
                      name: "RM Ticket",
                    },
                    {
                      id: "client_pending_cost",
                      name: "Client(Pending Cost approval)",
                    },
                    {
                      id: "ct_ticket",
                      name: "Central Tech Engineer",
                    },
                    {
                      id: "cx_pending",
                      name: "CX Pending",
                    }
                  ]}
                  required
                  errorMsg={`Send To`}
                  getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, send_to: val?.id });
                  }}
                  isStarRequired={true}
                />
                </>
            }
            
              {filterFieldsData && filterFieldsData?.send_to == 'Client' ? 
                  <Checkbox
                  label={'Attachment Mandatory'}
                  onChange={(val) => setFilterFieldsData({ ...filterFieldsData, attachment_mand: val })}
                  type="checkbox"
                />
              :
              null
              }
              <FileUpload
                  multiple
                  id={"addAttachment"}
                  accept=".pdf,.png,.jpg,.jpeg,.doc,.xlsx,.xls"
                  documentUploadUrl={documentUploadUrlPublic}
                  onChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, attachment_file: val })
                  }
                >
                <span className="btn btn-transparent">
                    {localization.attachment}
                </span>
                </FileUpload>
                
              <hr/>

            <div className="btn-wrapper" >
              <button
                disabled={false}
                type="submit"
                className="btn btn-primary "
              >
                {`Submit`}
                {/* <img src={Images?.ArrowRight} alt="" /> */}
              </button>
              <br />
              <br />
              
            </div>
          </div>
        </div>
      )}
    </div>
    </form>
  );
};

export default ComplaintReply;
